import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

import ColorProvider from '../chrome/ColorProvider';
import Image from '../chrome/Image';
import Text from '../chrome/Text';

const TeaserWrapper = styled('div', {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'compact',
})`
  text-align: center;
  padding: ${({ theme, compact }) => (compact ? `${theme.spacings.tera} 0 0` : theme.spacings.tera)};
`;

const TeaserRow = styled.div`
  color: ${({ theme }) => theme.colors.n700};
`;

const TeaserImage = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.giga};
`;

const TeaserText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.byte};
`;

const IntroTitleContainer = styled(Text)`
  line-height: 22px;
  margin-bottom: ${({ theme }) => theme.spacings.byte};
`;

const Teaser = ({ text, introTitle, introText, introSubTitle, compact, ...props }) => (
  <TeaserWrapper compact={compact}>
    {(introTitle || introText) && (
      <TeaserRow>
        <TeaserText>
          <ColorProvider variant='black'>
            {introTitle && (
              <IntroTitleContainer size='zetta' bold>
                {introTitle}
              </IntroTitleContainer>
            )}
            {introSubTitle && <IntroTitleContainer size='tera'>{introSubTitle}</IntroTitleContainer>}
            {introText && (
              <Text size='giga' bold>
                {introText}
              </Text>
            )}
          </ColorProvider>
        </TeaserText>
      </TeaserRow>
    )}
    <TeaserRow>
      <TeaserImage>
        <Image {...props} />
      </TeaserImage>
    </TeaserRow>
    {text && (
      <TeaserRow>
        <TeaserText>
          <Text size='tera' bold upper noMargin>
            {text}
          </Text>
        </TeaserText>
      </TeaserRow>
    )}
  </TeaserWrapper>
);

Teaser.propTypes = {
  introTitle: PropTypes.string,
  introSubTitle: PropTypes.string,
  introText: PropTypes.string,
  text: PropTypes.string,
  compact: PropTypes.bool,
};

Teaser.defaultProps = {
  compact: false,
};

export default Teaser;
